import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

const instructions: React.ReactNode[] = [
  <>
    Answer <b>all</b> questions.
  </>,
  <>
    In each of the questions <b>1</b> to <b>40</b>, pick one of the alternatives (1), (2), (3), (4)
    is <b>correct or most appropriate</b>.
  </>,
  <>
    <b>Mark a cross (✕) on the number corresponding to your choice in the answer sheet provided.</b>
  </>,
  <>Further instructions are given on the back of the answer sheet. Follow them carefully.</>,
];

const readingTime = [
  { label: 'අමතර කියවීම් කාලය', time: 'මිනිත්තු 10 යි' },
  { label: 'மேலதிக வாசிப்பு நேரம்', time: '10 நிமிடங்கள்' },
  { label: 'Additional Reading Time', time: '10 minutes', bold: true },
];

const serif = '"Times New Roman", Times, serif';

/** The exam paper's front-page instructions, shown before a student picks a paper. */
const CbaInstructions: FC = () => (
  <Box
    sx={{
      mt: 3,
      p: { xs: 2, md: 3 },
      background: '#fff',
      boxShadow: '0 2px 12px #0000001A',
      fontFamily: serif,
    }}
  >
    <Typography
      sx={{
        fontFamily: serif,
        fontSize: { xs: 20, md: 28 },
        fontWeight: 500,
        pb: 1,
        borderBottom: '1px solid #bdbdbd',
      }}
    >
      General Certificate of Education (Ord. Level) Examination
    </Typography>

    <Typography sx={{ fontFamily: serif, fontWeight: 700, mt: 2 }}>Instructions:</Typography>
    <Box
      component='ul'
      sx={{ m: 0, pl: 4, listStyleType: '"⊛  "', fontStyle: 'italic', fontFamily: serif }}
    >
      {instructions.map((instruction, i) => (
        <li key={i}>{instruction}</li>
      ))}
    </Box>

    <Typography sx={{ fontFamily: serif, fontWeight: 700, fontSize: 14, mt: 1.5, pl: 2 }}>
      Duration: 60 minutes
    </Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, pl: 2, alignItems: 'center' }}>
      <Box component='table' sx={{ fontSize: 13, borderCollapse: 'collapse', '& td': { pr: 1.5 } }}>
        <tbody>
          {readingTime.map((row) => (
            <tr key={row.label} style={{ fontWeight: row.bold ? 700 : 400 }}>
              <td>{row.label}</td>
              <td>- {row.time}</td>
            </tr>
          ))}
        </tbody>
      </Box>
      <Typography
        sx={{
          fontFamily: serif,
          fontWeight: 700,
          fontSize: 13,
          textAlign: 'center',
          flex: 1,
          minWidth: 220,
        }}
      >
        Use additional reading time to go through the question paper, select the questions and
        decide on the questions that you give priority in answering.
      </Typography>
    </Box>

    <Typography sx={{ fontFamily: serif, fontStyle: 'italic', fontSize: 12, mt: 1.5 }}>
      ** due to unavoidable circumstance only the MCQ papers may be tested by the students at this
      time.
    </Typography>
  </Box>
);

export default CbaInstructions;
